import {
  Topo,
  ServiceTopo,
  ServicesTopo,
  TopoMetric,
  TopoInstanceDependency,
  TopoInstanceClientInfo,
  TopoInstanceServerInfo,
  TopoServiceMetric,
  TopoClientMetric,
  TopoServiceInfo,
  TopoClientInfo,
  DependencyInstanceServerMetric,
  DependencyInstanceClientMetric,
  TopoServiceDetail,
  endpointTopology,
  TopoEndpointDependencyMetrics
} from '../fragments/topology';

export const queryTopo = `query queryTopo(${Topo.variable}) {${Topo.query}}`;

export const queryServiceTopo = `query queryServiceTopo(${ServiceTopo.variable}) {${ServiceTopo.query}}`;

export const queryServicesTopo = `query queryServiceTopo(${ServicesTopo.variable}) {${ServicesTopo.query}}`;

// export const queryTopoInfo = `query queryTopoInfo(
//     ${Topo.variable},
//     ${TopoMetric.variable},
//     ${TopoServiceMetric.variable},
//     ${TopoClientMetric.variable})
//       {
//         ${TopoMetric.query},
//         ${TopoServiceMetric.query},
//         ${TopoClientMetric.query}
//       }`;

export const queryTopoInfo = `query queryTopoInfo(
    ${Topo.variable},
    $metric: [MetricIdsConditions!]!)
    {
      getMetricAggregatedValues(metric: $metric, duration: $duration) {
        key
        values {
          values {
          id
          value
          }
        }
      }
    }`;
export const queryTopoServiceInfo = `query queryTopoServiceInfo(
  ${TopoServiceInfo.variable}) {${TopoServiceInfo.query}}`;

export const queryTopoClientInfo = `query queryTopoClientInfo(
  ${TopoClientInfo.variable}) {${TopoClientInfo.query}}`;

export const queryTopoInstanceDependency = `query queryTopoInstanceDependency(
  ${TopoInstanceDependency.variable}) {${TopoInstanceDependency.query}}`;

export const queryTopoInstanceServerInfo = `query queryTopoInstanceServerInfo(
  ${TopoInstanceServerInfo.variable}) {${TopoInstanceServerInfo.query}}`;

export const queryTopoInstanceClientInfo = `query queryTopoInstanceClientInfo(
  ${TopoInstanceClientInfo.variable}) {${TopoInstanceClientInfo.query}}`;

export const queryDependencyInstanceServerMetric = `query queryDependencyInstanceServerMetric(
  ${DependencyInstanceServerMetric.variable}) {${DependencyInstanceServerMetric.query}}`;

export const queryDependencyInstanceClientMetric = `query queryDependencyInstanceClientMetric(
  ${DependencyInstanceClientMetric.variable}) {${DependencyInstanceClientMetric.query}}`;

export const queryTopoServiceDetail = `query queryTopoServiceDetail(
  ${TopoServiceDetail.variable}) {${TopoServiceDetail.query}}`;

export const queryEndpointTopology = `query queryEndpointTopology(${endpointTopology.variable}) {${endpointTopology.query}}`;

export const queryTopoEndpointDependencyMetrics = `query queryTopoEndpointDependencyMetrics(
  ${TopoEndpointDependencyMetrics.variable}) {${TopoEndpointDependencyMetrics.query}}`;
